import { PersonAcademicTitle } from '@raisin/cp-utils';
export const messages = {
    [PersonAcademicTitle.ProfDrMed]: 'layout.customerName.academicTitle.academic_title_prof_dr_med',
    [PersonAcademicTitle.ProfDrDr]: 'layout.customerName.academicTitle.academic_title_prof_dr_dr',
    [PersonAcademicTitle.ProfDr]: 'layout.customerName.academicTitle.academic_title_prof_dr',
    [PersonAcademicTitle.Prof]: 'layout.customerName.academicTitle.academic_title_prof',
    [PersonAcademicTitle.DrMed]: 'layout.customerName.academicTitle.academic_title_dr_med',
    [PersonAcademicTitle.DrDr]: 'layout.customerName.academicTitle.academic_title_dr_dr',
    [PersonAcademicTitle.Dr]: 'layout.customerName.academicTitle.academic_title_dr',
};
//# sourceMappingURL=messages.js.map